// Whether the viewer may start a new conversation. The server sets the flag (Interact::MessagingEligibility):
// a new account waits for staff vetting. An absent flag means allowed; the server refuses anyway.
export default function mayStartConversations() {
  return globalThis.Qwoted?.CURRENT_USER_MAY_START_CONVERSATIONS !== false;
}
